var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer mt-4 py-3 content"},[_c('div',{staticClass:"container-fluid"},[_c('component-advertisement-bottom')],1),_c('div',[_vm._v(_vm._s(_vm.copyRight))])])}
var staticRenderFns = []

export { render, staticRenderFns }